import { render } from "./DataEditor.vue?vue&type=template&id=9f3aeba8"
import script from "./DataEditor.vue?vue&type=script&lang=js"
export * from "./DataEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__